import Api from "../../../util/Api";

export default function getInitState() {
    return {
        tableIsShow: true,
        formIsShow: false,

        actions: [
            {
                btn_text: '<i class="fas fa-plus"></i> Új template',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newRow'
            }
        ],
        rowActions: [
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyRow'
            },
            {
                btn_text: '<i class="fas fa-file-download"></i>',
                title: 'Letöltés',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'download'
            }
        ],
        formActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToGrid'
            }
        ],
        headerFields: [
            {
                label: "ID",
                name: "id",
                visibility: false,
                formVisible: false
            },
            {
                label: "Telephely",
                name: 'siteId',
                visibility: false,
                formSize: 4,
                formType: 'select',
                formRequired: true,
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getCompanySitesByCompanyId,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'keresés',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "companySite.siteName",
                label: "Telephely",
                filter: {
                    type: "simple",
                },
                visibility: true,
                formVisible: false
            },
            {
                name: "name",
                label: "Név",
                filter: {
                    type: "simple",
                },
                formSize: 4,
                formType: 'text',
                formRequired: true,
                formVisible: true
            },
            {
                name: "key",
                label: "Kulcs",
                visibility: false,
                formSize: 4,
                formType: 'select',
                formRequired: true,
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getGeneralDocumentKeys,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'keresés',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "keyType.text",
                label: "Kulcs",
                filter: {
                    type: "simple",
                },
                visibility: true,
                formVisible: false
            },
            {
                name: "fileName",
                label: "Fájl név",
                visibility: false,
                formVisible: false
            },
            {
                name: "fileType",
                label: "Fájl típus",
                visibility: false,
                formVisible: false
            },
            {
                name: "createdBy",
                label: "Készítő",
                visibility: true,
                formVisible: false
            },
            {
                name: "createdOn",
                label: "Készítés dátuma",
                visibility: true,
                slot_name: "created_on_format",
                formVisible: false
            },
            {
                name: "modifiedBy",
                label: "Módosító",
                visibility: true,
                formVisible: false
            },
            {
                name: "modifiedOn",
                label: "Módosítás dátuma",
                slot_name: "modified_on_format",
                visibility: true,
                formVisible: false
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ]
    }
}
